import React from 'react';
import { Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

import Main from '../../components/layout/Main';
import UserListingTable from '../../components/UserListingTable';

import './usersListing.scss';

const UsersListing = () => {
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];
    const navigation = [{ label: 'Item 1', link: '/abc' }, { label: 'Item 1', link: '/abc' }];

    return (
        <Main
            className="data-listing"
            title={<div>Vartotojų administravimas</div>}
            headerTitle={<div>Vartotojų administravimas</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div />}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <UserListingTable
                showCreateButton
                showFilters
                showSearch
                showReloadButton
                title="Vartotojai" />
        </Main>
    );
};

export default UsersListing;

UsersListing.propTypes = {};
